export default __webpack_public_path__ + "static/media/about-bg.26cb23cb.jpg";